/** Attendance alerts permission strings (mirror backend PermissionCatalog). */
export const AlertsPermissions = {
  viewHistory: 'alerts_view_history',
  viewPiiPdf: 'alerts_view_pii_pdf',
  viewRecipients: 'alerts_view_recipients',
  manageSchedules: 'alerts_manage_schedules',
  testSend: 'alerts_test_send',
  manualSend: 'alerts_manual_send',
  enableProduction: 'alerts_enable_production',
} as const
